import ContactUsForm from './ContactUsForm'
import {
  FullWidthBlock
} from '../../components/Blocks'

const ContactUs = ({ onSubmit }) => {
  return (
    <FullWidthBlock>
      <ContactUsForm onSubmit={onSubmit} />
    </FullWidthBlock>
  )
}

export default ContactUs
